import React from "react";

function Main() {
  return (
    <>
      <h1>REACT-Hooks</h1>
    </>
  );
}

export default Main;
